import {
  RequestItemModel
} from '@/groupBuy/types'
export class State {
  requestList: RequestItemModel[]
  notifications: {
    [key: string]: string
  }
  constructor() {
    this.requestList = []
    this.notifications = {}
  }
}
